import { postCourierLocationApi } from '@/entities/courier/api/courierApi'
import { getCourierGeolocation } from '@/entities/courier/lib/courierGeolocation'
import { useCourierStore } from '@/entities/courier/model/useCourierStore'

export const COURIER_LOCATION_TRACKING_INTERVAL_MS = 15000

let intervalId = null
let isSending = false

function shouldTrackLocation() {
  return useCourierStore().activeOrderIds.length > 0
}

async function sendCourierLocation() {
  if (isSending) {
    return
  }

  if (!shouldTrackLocation()) {
    stopCourierLocationTracking()
    return
  }

  isSending = true
  try {
    const position = await getCourierGeolocation({ maximumAge: 0 })
    await postCourierLocationApi(position)
  } catch (error) {
    console.warn('[courier] location tracking failed', error)
  } finally {
    isSending = false
  }
}

export function syncCourierLocationTracking() {
  if (shouldTrackLocation()) {
    startCourierLocationTracking()
    return
  }
  stopCourierLocationTracking()
}

export function startCourierLocationTracking() {
  if (intervalId) {
    return
  }

  void sendCourierLocation()
  intervalId = setInterval(() => {
    void sendCourierLocation()
  }, COURIER_LOCATION_TRACKING_INTERVAL_MS)
}

export function stopCourierLocationTracking() {
  if (intervalId) {
    clearInterval(intervalId)
    intervalId = null
  }
  isSending = false
}
